module.exports = "<iframe src=\"https://portal.audioeye.com/accessibility-statement.html?domain=order.wbu.com&fallbackLng=en\" title=\"Accessibility Statement\" style=\"width:100%;height:2300px\" frameborder=1></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/order/accessibility/accessibility.html
// module id = 212
// module chunks = 0